import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MiniSideBar from "./MiniSideBar/MiniSideBar";
import ChatSideBar from "./ChatMenu/ChatSideBar/ChatSideBar";
import ChatingSection from "./ChatMenu/ChatingSection/ChatingSection";
import ProfileView from "./ChatMenu/ProfileView/ProfileView";
import GroupChatSideBar from "./GroupMenu/GroupChatSideBar/GroupChatSideBar";
import ChatingGroupSection from "./GroupMenu/ChatingGroupSection/ChatingGroupSection";
import GroupProfileView from "./GroupMenu/GroupProfileView/GroupProfileView";
import ChannelSidebar from "./ChannelMenu/ChannelSidebar/ChannelSidebar";
import ChatingChannelSection from "./ChannelMenu/ChatingChannelSection/ChatingChannelSection";
import ChannelProfileView from "./ChannelMenu/ChannelProfileView/ChannelProfileView";
import SettingsSideBar from "./SettingsMenu/SettingsSideBar/SettingsSideBar";
import ThemeToggle from "../Components/ThemeToggle/ThemeToggle";
import {
  getApiCaller,
  postApiCaller,
  postFormDataApiCaller,
} from "../Libs/apiCaller";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { chatUserData, converId } from "../Redux/slices/ChatSlice";
import {
  decryptMessage,
  decryptText,
  encrypt,
} from "../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { v4 as uuidv4 } from "uuid";
import SettingsInnerPage from "../Pages/Settings/SettingsInnerPage/SettingsInnerPage";
import { connectWebSocket, getSocket } from "../Libs/socket";
import { useNotificationSystem } from "../hooks/useNotificationSystem";

export default function Layout({ children, showGroupSection, isNewChannel }) {
  const { socket, isConnected } = useSelector((state) => state.socket);
  const { channelSlug } = useParams();
  const dispatch = useDispatch();
  const location = useLocation(); // Get the current route
  const navigate = useNavigate();
  const [showProfileView, setShowProfileView] = useState(false);
  const [isAlluserLoading, setIsAlluserLoading] = useState(false);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [otherChannelChatMsg, setOtherChannelChatMsg] = useState({
    channel: false,
    group: false,
    chat: false,
  });
  const [createChatId, setCreateChatId] = useState("");
  const [chatSearch, setChatSearch] = useState("");
  const [allUserSearch, setAllUserSearch] = useState("");
  const [moreNewChat, setMoreNewChat] = useState(false);
  const [AllUser, setAllUser] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [chatUsers, setChatUsers] = useState([]);
  const [activeSection, setActiveSection] = useState("contact"); // 👈 new state
  const [showAddGroupMember, setShowAddGroupMember] = useState(false); // State to toggle sections
  const isGroupRoute = location.pathname.startsWith("/group");
  const isChatRoute = location.pathname.startsWith("/home");
  const [activeChat, setActiveChat] = useState();
  const [groupActiveChat, setGroupActiveChat] = useState(null);
  const [chatConversationId, setChatConversationId] = useState("");
  const [channelActiveChat, setChannelActiveChat] = useState();
  const [allMessages, setAllMessages] = useState([]);
  // OPTIMIZATION: Cache messages per conversation to avoid refetching
  const messagesCacheRef = useRef(new Map()); // conversationId -> { messages, timestamp, page, totalPages, decryptedMessages, secretKey }
  const [allGroups, setAllGroups] = useState([]);
  const [groupPage, setGroupPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [getSecretKey, setGetSecretKey] = useState("");
  const [channels, setChannels] = useState([]);
  const [allUserCurrentPage, setAllUserCurrentPage] = useState(1);
  const [allUserTotalPages, setAllUserTotalPages] = useState(1);
  const [chatPage, setChatPage] = useState(1);
  const [chatTotalPages, setChatTotalPages] = useState(1);
  const [messageTotalPages, setMessageTotalPages] = useState(1);
  const [messageCurrentPage, setMessageCurrentPage] = useState(1);
  const [showAddMenu, setShowAddMenu] = useState(false);

  // Helper to update messages and cache together
  const updateMessagesAndCache = (newMessages, page = messageCurrentPage, totalPages = messageTotalPages) => {
    setAllMessages(newMessages);
    const conversationId = typeof chatConversationId === "string"
      ? chatConversationId
      : chatConversationId?._id;
    if (conversationId) {
      const cached = messagesCacheRef.current.get(conversationId) || {};
      messagesCacheRef.current.set(conversationId, {
        messages: newMessages,
        timestamp: Date.now(),
        page,
        totalPages,
        secretKey: cached.secretKey, // Preserve secret key
      });
    }
  };
  const [timeOutIdForSearch, setTimeOutIdForSearch] = useState(null);
  const { userInfo } = useSelector((state) => state.authUser);
  const { isSocketConnected, conversationId } = useSelector(
    (state) => state.chatUser
  );
  const [settings, setSettings] = useState({});
  const uid = localStorage.getItem("userId");
  const [channelCurrentPage, setChannelCurrentPage] = useState(1);
  const [channelTotalPages, setChannelTotalPages] = useState(1);
  const [channelSearch, setChannelSearch] = useState("");
  const [channelLoading, setChannelLoading] = useState(false);
  const [isNewUserMessage, setIsNewUserMessage] = useState(false);
  const [groupCurrentPage, setGroupCurrentPage] = useState(1);
  const [groupTotalPages, setGroupTotalPages] = useState(1);
  const [groupSearch, setGroupSearch] = useState("");
  const [groupLoading, setGroupLoading] = useState(false);

  // Typing indicator state
  const [typingUsers, setTypingUsers] = useState(new Set());
  const typingTimeouts = useRef({});

  useEffect(() => {
    dispatch(connectWebSocket());
  }, []);

  // When profile view is opened, default to "contact"
  const handleOpenProfile = () => {
    setActiveSection("contact");
    setShowProfileView(true);
  };

  const toggleAddGroupMember = (state) => {
    // Use setShowAddGroupMember instead of setAddGroupMemberVisible
    setShowAddGroupMember(state);
  };

  const isChannelRoute = location.pathname.startsWith("/channels");
  const isSettingsRoute = location.pathname.startsWith("/settings");
  const isSettingsOtherRoute =
    location.pathname.startsWith("/settings/terms-and-conditions") ||
    location.pathname.startsWith("/settings/privacy-policy") ||
    location.pathname.startsWith("/settings/about-us") ||
    location.pathname.startsWith("/settings/help-center");
  const conversationIdRef = useRef(conversationId);

  useEffect(() => {
    if (isChannelRoute) fetchChannels();
  }, [isChannelRoute]);

  useEffect(() => {
    if (uid && socket) {
      socket.on(`seen-message-${uid}`, ({ conversationId }) => {
        if (!conversationId) return;
        if (isChatRoute) {
          setChatUsers((prev) =>
            prev.map((user) => {
              if (user?.conversationId?._id === conversationId) {
                return { ...user, unseenMessageCount: 0 };
              }
              return user;
            })
          );
        } else if (isGroupRoute) {
          setAllGroups((prev) =>
            prev.map((group) => {
              if (group?.conversationId?._id === conversationId) {
                return { ...group, unseenMessageCount: 0 };
              }
              return group;
            })
          );
        } else if (isChannelRoute) {
          setChannels((prev) =>
            prev.map((channel) => {
              if (channel?.conversationId?._id === conversationId) {
                return { ...channel, unseenMessageCount: 0 };
              }
              return channel;
            })
          );
        }
      });

      // Typing indicator listeners
      socket.on('userTyping', ({ userId }) => {
        setTypingUsers(prev => new Set(prev).add(userId));

        // Auto-clear after 3 seconds
        if (typingTimeouts.current[userId]) {
          clearTimeout(typingTimeouts.current[userId]);
        }
        typingTimeouts.current[userId] = setTimeout(() => {
          setTypingUsers(prev => {
            const newSet = new Set(prev);
            newSet.delete(userId);
            return newSet;
          });
        }, 3000);
      });

      socket.on('userStoppedTyping', ({ userId }) => {
        setTypingUsers(prev => {
          const newSet = new Set(prev);
          newSet.delete(userId);
          return newSet;
        });
        if (typingTimeouts.current[userId]) {
          clearTimeout(typingTimeouts.current[userId]);
        }
      });

      return () => {
        socket.off(`seen-message-${uid}`);
        socket.off('userTyping');
        socket.off('userStoppedTyping');
      };
    }
  }, [socket, uid]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const entityId = searchParams.get("entityId");

    // Remove entityId from URL without refreshing page, but PRESERVE React Router state
    const newUrl = window.location.pathname + window.location.hash;
    window.history.replaceState(window.history.state, "", newUrl);

    if (entityId) {
      if (isChannelRoute) {
        fetchChannelById(entityId);
      } else if (isGroupRoute) {
        fetchGroupById(entityId);
      } else if (isChatRoute) {
        fetchChatById(entityId);
      }
    }
  }, [location.search, isChannelRoute, isGroupRoute, isChatRoute]);

  const fetchChatById = async (id) => {
    // OPTIMIZATION: Check if we already have this chat in chatUsers to avoid unnecessary API call
    const existingChat = chatUsers.find((chat) => chat._id === id);
    if (existingChat) {
      // Use existing data - just set up the conversation
      const conversationId = existingChat.conversationId?._id || existingChat.conversationId;

      // Set activeChat FIRST so cache check can use it
      setActiveChat(existingChat);
      setChatConversationId(existingChat.conversationId);
      dispatch(chatUserData(existingChat));

      // Get secret key (will use cache if available)
      getSecretKeyFunction(
        existingChat.conversationId.AESKeyOfUser,
        conversationId
      ).catch(() => { });
      return;
    }

    // Only fetch from API if we don't have the chat data
    const endpoint = `chat/${id}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      const conversationId = response.data.data.conversationId?._id || response.data.data.conversationId;

      // Set activeChat FIRST so cache check can use it
      setActiveChat(response.data.data);
      setChatConversationId(response.data.data.conversationId);
      dispatch(chatUserData(response.data.data));

      // Get secret key (will use cache if available)
      getSecretKeyFunction(
        response.data.data.conversationId.AESKeyOfUser,
        conversationId
      ).catch(() => { });
    }
  };

  const fetchChannelById = async (id) => {
    const endpoint = `channel/${id}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      await getSecretKeyFunction(
        response.data.data.conversationId.AESKeyOfUser
      );
      setChatConversationId(response.data.data.conversationId);
      setChannelActiveChat(response.data.data);
    }
  };

  const fetchGroupById = async (id) => {
    const endpoint = `group/${id}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      await getSecretKeyFunction(
        response.data.data.conversationId.AESKeyOfUser
      );
      setChatConversationId(response.data.data.conversationId);
      setGroupActiveChat(response.data.data);
    }
  };

  const fetchChannels = async (
    isLoadingShow,
    page = channelCurrentPage,
    srch = channelSearch
  ) => {
    !isLoadingShow && setChannelLoading(true);
    let endpoint = `channel/my-channel?page=${page}`;
    setChannelSearch(srch);
    if (srch.trim()) {
      endpoint += `&search=${srch}`;
    }
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      if (page == 1) setChannels(response.data.data);
      else setChannels((prev) => [...prev, ...response.data.data]);
      setChannelCurrentPage(response?.data?.pagination?.currentPage || 1);
      setChannelTotalPages(response?.data?.pagination?.totalPages || 1);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setChannelLoading(false);
  };

  const fetchGroups = async (
    isLoadingShow,
    page = groupCurrentPage,
    srch = groupSearch
  ) => {
    !isLoadingShow && setGroupLoading(true);
    let endpoint = `group/my-groups?page=${page}`;
    setGroupSearch(srch);
    if (srch.trim()) {
      endpoint += `&search=${srch}`;
    }
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      setGroupCurrentPage(response?.data?.pagination?.currentPage || 1);
      setGroupTotalPages(response?.data?.pagination?.totalPages || 1);
      setAllGroups((prev) =>
        page == 1 ? response.data.data : [...prev, ...response.data.data]
      );
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setGroupLoading(false);
  };

  const getSecretKeyFunction = async (AESKeyOfUser, conversationId) => {
    // OPTIMIZATION: Cache secret keys per conversation
    const convId = conversationId || (typeof chatConversationId === "string"
      ? chatConversationId
      : chatConversationId?._id);

    if (convId) {
      const cached = messagesCacheRef.current.get(convId);
      if (cached?.secretKey) {
        setGetSecretKey(cached.secretKey);
        return cached.secretKey;
      }
    }

    const getKey = await decryptText(
      AESKeyOfUser,
      userInfo?.encryptedPrivateKey
    );
    setGetSecretKey(getKey);

    // Cache the secret key
    if (convId) {
      const cached = messagesCacheRef.current.get(convId) || {};
      messagesCacheRef.current.set(convId, {
        ...cached,
        secretKey: getKey,
      });
    }

    return getKey;
  };

  // Keep the ref updated whenever conversationId changes
  useEffect(() => {
    conversationIdRef.current = conversationId;
  }, [conversationId]);

  useEffect(() => {
    if (
      location.pathname === "/home" &&
      location?.state?.chat &&
      userInfo?.encryptedPrivateKey
    ) {
      getSecretKeyFunction(
        location.state.chat.conversationId.AESKeyOfUser
      ).then(() => {
        setChatConversationId(location.state.chat.conversationId);
        dispatch(chatUserData(location.state.chat));
        setActiveChat(location.state.chat);
        navigate(location.pathname, { replace: true });
      });
    }
  }, [location, userInfo]);

  useEffect(() => {
    if (channelSlug) {
      setIsMessageLoading(true);
    }
    if (userInfo?.encryptedPrivateKey && channelSlug) {
      getChannelDetails(channelSlug);
    }
  }, [channelSlug, userInfo]);

  useEffect(() => {
    if (userInfo?.encryptedPrivateKey && groupActiveChat?._id) {
      getSettings("group", groupActiveChat._id);
    }
  }, [userInfo, groupActiveChat]);

  // Settings are now loaded in parallel with messages in the chatConversationId useEffect
  // This useEffect is kept as a fallback for edge cases
  useEffect(() => {
    if (userInfo?.encryptedPrivateKey && activeChat?._id && !chatConversationId?._id) {
      getSettings("chat", activeChat?._id);
    }
  }, [userInfo, activeChat]);

  useEffect(() => {
    if (createChatId) {
      createChat();
    }
  }, [createChatId]);

  const createChat = async () => {
    const endPoint = "chat/create";
    const response = await postApiCaller(endPoint, { user: createChatId });
    if (response?.status === 200) {
      getSecretKeyFunction(
        response?.data?.data?.conversationId?.AESKeyOfUser
      ).then(() => {
        setCreateChatId("");
        setChatConversationId(response?.data?.data.conversationId);
        dispatch(converId(response?.data?.data?.conversationId?._id));
        dispatch(chatUserData(response?.data?.data));
        setActiveChat(response?.data?.data);
        if (!response?.data?.data?.user.isBlocked) {
          socket.emit("joinConversation", {
            id: response?.data?.data?.conversationId?._id,
          });
        }
      });
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  // useEffect(() => {
  //   fetchAllUser();
  //   fetchChatList();
  // }, []);

  useEffect(() => {
    // if (!moreNewChat) {
    //   setTimeout(() => {
    //     fetchChatList();
    //   }, 1000);
    // }
    setIsAlluserLoading(true);
    fetchAllUser(1, "");
  }, [moreNewChat]);

  const fetchAllUser = async (page = allUserCurrentPage, search) => {
    // !isShowLoading && setIsAlluserLoading(true);
    let endpoint;
    if (search === "") {
      endpoint = `users/all_user_app?page=${page}&limit=20`;
    } else {
      endpoint = `users/all_user_app?page=${page}&limit=20&search=${search}`;
    }

    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      setUserSearch(search);
      setAllUser((prev) =>
        page == 1 ? response.data.users : [...prev, ...response.data.users]
      );
      setAllUserCurrentPage(response.data.pagination.currentPage);
      setAllUserTotalPages(response.data.pagination.totalPages);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setTimeout(() => { }, 400);
    setIsAlluserLoading(false);
  };

  const containsLink = (message) => {
    // Match URLs with or without protocol (http/https)
    const urlRegex =
      /(?:https?:\/\/)?(?:www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;
    const urls = message.match(urlRegex);
    return urls ? urls[0] : null;
  };

  const sendMessage = async (message) => {
    // Decrypt AES key
    const getKey = await decryptText(
      chatConversationId?.AESKeyOfUser,
      userInfo?.encryptedPrivateKey
    );
    const { iv, encryptedData } = await encrypt(message, getKey);
    const endPoint = "messages/send";
    const randomId = Math.random().toString(36).substring(2, 15);
    const messageId = uuidv4();
    const formData = new FormData();
    formData.append(
      "conversationId",
      typeof chatConversationId == "string"
        ? chatConversationId
        : chatConversationId._id
    );
    formData.append("cipherText", encryptedData);
    formData.append("iv", iv);
    formData.append("isLink", containsLink(message) ? "true" : "false");
    formData.append("messageId", messageId);
    // Backend requires messageType - determine based on content
    const messageType = containsLink(message) ? "LINK" : "TEXT";
    formData.append("messageType", messageType);
    formData.append("content", message); // Send plaintext content for search indexing

    setAllMessages((prev) => {
      const userId = localStorage.getItem("userId");
      const newMessage = {
        cipherText: encryptedData,
        iv,
        _id: randomId,
        loading: true,
        senderId: { _id: userId },
        sentTime: new Date().toISOString(),
        messageId,
      };

      const updatedMessages = prev.length === 0 ? [newMessage] : [newMessage, ...prev];

      // Update cache when sending a message
      const conversationId = typeof chatConversationId == "string"
        ? chatConversationId
        : chatConversationId?._id;
      if (conversationId) {
        const cached = messagesCacheRef.current.get(conversationId) || {};
        messagesCacheRef.current.set(conversationId, {
          messages: updatedMessages,
          timestamp: Date.now(),
          page: cached.page || messageCurrentPage,
          totalPages: cached.totalPages || messageTotalPages,
          secretKey: cached.secretKey, // Preserve secret key
        });
      }

      return updatedMessages;
    });
    setShowAddMenu(false);
    await postFormDataApiCaller(endPoint, formData);
  };

  function categorizeFile(file) {
    if (!file || !file.type) return "document";

    const type = file.type;
    if (!type) return "document";

    if (type.startsWith("image/")) return "image";
    if (type.startsWith("video/")) return "video";
    if (type.startsWith("audio/")) return "audio";

    return "document";
  }

  const sendFilesInMessage = async (files, message = null) => {
    console.log('[FILE UPLOAD] Starting file upload process', {
      fileCount: files.length,
      files: files.map(f => ({ name: f.name, size: f.size, type: f.type }))
    });

    // Check if files exceed maximum limit
    if (files.length > 10) {
      toast.error("Maximum 10 files can be uploaded at a time");
      return;
    }

    const endPoint = "messages/send";

    // Process each file individually - using for...of to properly handle async
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const randomId = Math.random().toString(36).substring(2, 15);
      const messageId = uuidv4();

      try {
        console.log(`[FILE UPLOAD] Processing file ${index + 1}/${files.length}`, {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          messageId,
          randomId
        });

        // Validate conversation ID
        if (!chatConversationId?._id) {
          console.error('[FILE UPLOAD] Missing conversationId', { chatConversationId });
          toast.error(`Failed to upload ${file.name}: Missing conversation ID`);
          continue;
        }

        // Create new FormData for each file
        const formData = new FormData();
        formData.append("conversationId", chatConversationId._id);
        formData.append("messageMedia", file);
        formData.append("messageId", messageId);
        formData.append("messageType", "MEDIA"); // Required by backend for media messages
        formData.append("isLink", "false"); // Required by backend
        formData.append("isLocation", "false"); // Required by backend

        // Log FormData contents for debugging
        const formDataEntries = [];
        for (let pair of formData.entries()) {
          if (pair[1] instanceof File) {
            formDataEntries.push({ key: pair[0], value: `[File: ${pair[1].name}, size: ${pair[1].size}, type: ${pair[1].type}]` });
          } else {
            formDataEntries.push({ key: pair[0], value: pair[1] });
          }
        }

        console.log('[FILE UPLOAD] FormData created', {
          conversationId: chatConversationId._id,
          messageId,
          hasMessage: !!message,
          isFirstFile: index === 0,
          formDataEntries
        });

        let encryptedData = null;
        let iv = null;

        if (index === 0 && message) {
          try {
            console.log('[FILE UPLOAD] Encrypting message text...');
            const getKey = await decryptText(
              chatConversationId?.AESKeyOfUser,
              userInfo?.encryptedPrivateKey
            );
            const encrypted = await encrypt(message, getKey);
            encryptedData = encrypted.encryptedData;
            iv = encrypted.iv;
            formData.append("cipherText", encryptedData);
            formData.append("iv", iv);
            console.log('[FILE UPLOAD] Message encrypted successfully');
          } catch (encryptError) {
            console.error('[FILE UPLOAD] Encryption error', encryptError);
            toast.error(`Failed to encrypt message for ${file.name}`);
            continue;
          }

          setAllMessages((prev) => {
            const newMessage = {
              mediaUrl:
                categorizeFile(file) === "image" ||
                  categorizeFile(file) === "audio"
                  ? URL.createObjectURL(file)
                  : null,
              mediaId: {
                fileUrl: `messageMedia/${file.name}`,
                fileType: categorizeFile(file),
              },
              cipherText: encryptedData,
              iv,
              sentTime: new Date().toISOString(),
              loading: true,
              _id: randomId,
              messageId,
              senderId: { _id: localStorage.getItem("userId") },
            };

            console.log('[FILE UPLOAD] Adding message to state (with text)', {
              messageId,
              randomId,
              hasMediaUrl: !!newMessage.mediaUrl,
              loading: newMessage.loading
            });

            const updatedMessages = [newMessage, ...prev];

            // Update cache
            const conversationId = typeof chatConversationId === "string"
              ? chatConversationId
              : chatConversationId?._id;
            if (conversationId) {
              const cached = messagesCacheRef.current.get(conversationId) || {};
              messagesCacheRef.current.set(conversationId, {
                messages: updatedMessages,
                timestamp: Date.now(),
                page: cached.page || messageCurrentPage,
                totalPages: cached.totalPages || messageTotalPages,
                secretKey: cached.secretKey,
              });
            }

            return updatedMessages;
          });
        } else {
          setAllMessages((prev) => {
            const newMessage = {
              mediaUrl:
                categorizeFile(file) === "image" ||
                  categorizeFile(file) === "audio"
                  ? URL.createObjectURL(file)
                  : null,
              mediaId: {
                fileUrl: `messageMedia/${file.name}`,
                fileType: categorizeFile(file),
              },
              messageType: "MEDIA", // CRITICAL: Set messageType so image renders
              sentTime: new Date().toISOString(),
              loading: true,
              _id: randomId,
              messageId,
              senderId: { _id: localStorage.getItem("userId") },
            };

            console.log('[FILE UPLOAD] Adding message to state (no text)', {
              messageId,
              randomId,
              hasMediaUrl: !!newMessage.mediaUrl,
              loading: newMessage.loading
            });

            const updatedMessages = [newMessage, ...prev];

            // Update cache
            const conversationId = typeof chatConversationId === "string"
              ? chatConversationId
              : chatConversationId?._id;
            if (conversationId) {
              const cached = messagesCacheRef.current.get(conversationId) || {};
              messagesCacheRef.current.set(conversationId, {
                messages: updatedMessages,
                timestamp: Date.now(),
                page: cached.page || messageCurrentPage,
                totalPages: cached.totalPages || messageTotalPages,
                secretKey: cached.secretKey,
              });
            }

            return updatedMessages;
          });
        }

        // Make API call for each file
        console.log('[FILE UPLOAD] Sending API request...', {
          endpoint: endPoint,
          baseUrl: process.env.REACT_APP_PUBLIC_BASE_URL,
          fileSize: file.size
        });

        const response = await postFormDataApiCaller(endPoint, formData);

        // Log response structure for debugging
        console.log('[FILE UPLOAD] Response received', {
          hasResponse: !!response,
          isError: response instanceof Error,
          hasStatus: !!response?.status,
          hasResponseProperty: !!response?.response,
          status: response?.status,
          statusText: response?.statusText,
          responseKeys: response ? Object.keys(response) : []
        });

        // Check if response is an error
        // Successful axios responses have: { status, statusText, data, headers, ... }
        // Axios errors have: { response: { status, data, ... }, message, ... }
        // apiCaller returns the error object directly on failure
        if (!response || (response instanceof Error) || (response.response && !response.status && response.message)) {
          const error = response?.response || response;

          // Log detailed error information
          console.error('[FILE UPLOAD] API call failed', {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            status: error?.status,
            statusText: error?.statusText,
            data: error?.data,
            message: error?.message,
            fullError: error
          });

          // Log the actual server response message
          if (error?.data) {
            console.error('[FILE UPLOAD] Server error details:', JSON.stringify(error.data, null, 2));
          }

          // Extract error message from various possible locations
          const errorMessage = error?.data?.message ||
            error?.data?.error ||
            error?.message ||
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            `Server returned ${error?.status || 'unknown'} status`;

          toast.error(`Failed to upload ${file.name}: ${errorMessage}`);

          // Remove failed upload from messages - match by messageId
          setAllMessages((prev) => prev.filter((msg) => msg.messageId !== messageId));
          continue;
        }

        // Check if response status indicates success (2xx)
        if (response.status && (response.status < 200 || response.status >= 300)) {
          console.error('[FILE UPLOAD] API call returned non-success status', {
            fileName: file.name,
            status: response.status,
            statusText: response.statusText,
            data: response.data
          });

          toast.error(`Failed to upload ${file.name}: ${response.data?.message || response.statusText || 'Server error'}`);

          // Remove failed upload from messages - match by messageId
          setAllMessages((prev) => prev.filter((msg) => msg.messageId !== messageId));
          continue;
        }

        console.log('[FILE UPLOAD] API call successful', {
          fileName: file.name,
          status: response?.status,
          data: response?.data,
          messageId,
          randomId
        });

        // Update message status after successful upload
        // Match by messageId (UUID) since that's what we use for socket matching
        setAllMessages((prev) => {
          // Try to find by messageId first
          let messageIndex = prev.findIndex((msg) => msg.messageId === messageId);

          // If not found by messageId, try by _id (randomId) as fallback
          if (messageIndex === -1) {
            messageIndex = prev.findIndex((msg) => msg._id === randomId);
            console.log('[FILE UPLOAD] Message not found by messageId, trying by _id', {
              messageId,
              randomId,
              foundByRandomId: messageIndex !== -1
            });
          }

          if (messageIndex === -1) {
            console.error('[FILE UPLOAD] Message not found in state to update loading', {
              messageId,
              randomId,
              allMessageIds: prev.map(m => ({ messageId: m.messageId, _id: m._id, loading: m.loading }))
            });
            return prev;
          }

          const messageBeforeUpdate = prev[messageIndex];

          // SAFETY CHECK:
          // If the socket handler has already fully updated this message
          // (loading is already false AND we have a real DB id and/or mediaUrl),
          // then the HTTP handler should NOT touch it to avoid overwriting state.
          const hasRealId =
            messageBeforeUpdate._id && String(messageBeforeUpdate._id).length >= 15;
          const hasMediaUrl = !!messageBeforeUpdate.mediaUrl;

          if (messageBeforeUpdate.loading === false && (hasRealId || hasMediaUrl)) {
            console.log('[FILE UPLOAD] Skipping HTTP state update because socket already completed message', {
              messageId,
              randomId,
              hasRealId,
              hasMediaUrl,
              currentState: {
                _id: messageBeforeUpdate._id,
                loading: messageBeforeUpdate.loading,
                mediaUrl: messageBeforeUpdate.mediaUrl,
              },
            });
            return prev;
          }

          const updatedMessages = [...prev];
          const wasLoading = messageBeforeUpdate.loading;

          // CRITICAL: Explicitly set loading to false, don't rely on spread
          // Create a new object to ensure React detects the change
          updatedMessages[messageIndex] = {
            ...messageBeforeUpdate,
            loading: false
          };

          const messageAfterUpdate = updatedMessages[messageIndex];

          console.log('[FILE UPLOAD] Updated loading state', {
            messageId,
            randomId,
            found: true,
            wasLoading,
            nowLoading: messageAfterUpdate.loading,
            messageIndex,
            totalMessages: updatedMessages.length,
            arrayReferenceChanged: updatedMessages !== prev,
            messageReferenceChanged: messageAfterUpdate !== messageBeforeUpdate,
            loadingStateChanged: messageBeforeUpdate.loading !== messageAfterUpdate.loading,
            beforeUpdate: {
              messageId: messageBeforeUpdate.messageId,
              _id: messageBeforeUpdate._id,
              loading: messageBeforeUpdate.loading
            },
            afterUpdate: {
              messageId: messageAfterUpdate.messageId,
              _id: messageAfterUpdate._id,
              loading: messageAfterUpdate.loading
            }
          });

          // Update cache
          const conversationId = typeof chatConversationId === "string"
            ? chatConversationId
            : chatConversationId?._id;
          if (conversationId) {
            const cached = messagesCacheRef.current.get(conversationId) || {};
            messagesCacheRef.current.set(conversationId, {
              messages: updatedMessages,
              timestamp: Date.now(),
              page: cached.page || messageCurrentPage,
              totalPages: cached.totalPages || messageTotalPages,
              secretKey: cached.secretKey,
            });
          }

          return updatedMessages;
        });

      } catch (error) {
        console.error('[FILE UPLOAD] Unexpected error', {
          fileName: file.name,
          error: error.message,
          stack: error.stack,
          fullError: error
        });

        // Handle error for individual file
        toast.error(`Failed to upload ${file.name}: ${error.message || 'Unknown error'}`);

        // Remove failed upload from messages - match by messageId
        setAllMessages((prev) => prev.filter((msg) => msg.messageId !== messageId));
      }
    }

    console.log('[FILE UPLOAD] File upload process completed');
  };

  useEffect(() => {
    // Load messages immediately when the active conversation changes
    // Handle both string and object formats for chatConversationId
    let conversationId = null;

    if (chatConversationId) {
      if (typeof chatConversationId === "string") {
        conversationId = chatConversationId;
      } else if (chatConversationId._id) {
        conversationId = chatConversationId._id;
      } else if (typeof chatConversationId === "object" && chatConversationId.toString) {
        // Fallback: try to get string representation
        conversationId = String(chatConversationId);
      }
    }


    if (!conversationId) {
      // No conversation selected - but don't clear if we're in the middle of loading
      // This prevents race conditions where useEffect runs before conversationId is properly set
      if (!isMessageLoading && allMessages.length === 0) {
        setAllMessages([]);
        setIsMessageLoading(false);
        // Clear secret key when no conversation is selected
        setGetSecretKey("");
      } else {
      }
      return;
    }

    // CRITICAL: Clear secret key when switching conversations to prevent using wrong key
    // The secret key will be recalculated for the new conversation
    if (getSecretKey) {
      const currentConvId = typeof chatConversationId === "string"
        ? chatConversationId
        : chatConversationId?._id;
      // Only clear if we're switching to a different conversation
      if (currentConvId !== conversationId) {
        setGetSecretKey("");
      }
    }

    // OPTIMIZATION: Check cache first - instant load for previously viewed conversations
    const cached = messagesCacheRef.current.get(conversationId);

    if (cached && cached.messages && cached.messages.length > 0) {
      // Restore from cache instantly (no API call, no waiting)
      setAllMessages(cached.messages);
      setMessageCurrentPage(cached.page || 1);
      setMessageTotalPages(cached.totalPages || 1);
      setIsMessageLoading(false);

      // Restore secret key from cache if available
      if (cached.secretKey) {
        setGetSecretKey(cached.secretKey);
      } else if (activeChat?.conversationId?.AESKeyOfUser && userInfo?.encryptedPrivateKey) {
        // Calculate secret key if not cached - do this BEFORE setting messages
        getSecretKeyFunction(activeChat.conversationId.AESKeyOfUser, conversationId).then((key) => {
          // Messages will be decrypted with the correct key
        }).catch(() => { });
      }

      // Load settings in background (don't block)
      if (activeChat?._id && userInfo?.encryptedPrivateKey) {
        getSettings("chat", activeChat._id).catch(() => { });
      }

      // OPTIMIZATION: Only refresh in background if cache is > 30 seconds old
      const cacheAge = Date.now() - (cached.timestamp || 0);
      if (cacheAge > 30000) {
        // Cache is stale, refresh in background
        fetchMessagesForConversation(conversationId, 1, false).catch(() => { });
      }
      return;
    }

    // No cache - fetch fresh data (ALWAYS fetch, don't wait for activeChat)
    setIsMessageLoading(true);
    setAllMessages([]);
    setGroupPage(1);

    // CRITICAL: Set secret key BEFORE fetching messages to ensure correct key is used
    // This prevents race condition where messages are decrypted with wrong key
    const setSecretKeyFirst = async () => {
      if (activeChat?.conversationId?.AESKeyOfUser && userInfo?.encryptedPrivateKey) {
        await getSecretKeyFunction(activeChat.conversationId.AESKeyOfUser, conversationId).catch(() => { });
      }

      // Now fetch messages - they will be decrypted with the correct key
      return fetchMessagesForConversation(conversationId, 1, false);
    };

    setSecretKeyFirst().then(() => {

      // Double-check secret key is set (fallback if activeChat wasn't ready)
      if (!getSecretKey && activeChat?.conversationId?.AESKeyOfUser && userInfo?.encryptedPrivateKey) {
        getSecretKeyFunction(activeChat.conversationId.AESKeyOfUser, conversationId).catch(() => { });
      }

      // Load settings after messages load (activeChat should be set by then)
      if (activeChat?._id && userInfo?.encryptedPrivateKey) {
        getSettings("chat", activeChat._id).catch(() => { });
      }
    }).catch((err) => {
      console.error("Error loading chat data:", err);
      setIsMessageLoading(false);
    });
  }, [chatConversationId]);

  // Helper function to fetch messages for a specific conversationId
  const fetchMessagesForConversation = async (
    conversationId,
    curretPage,
    isShowLoading,
    shouldAppend = false
  ) => {
    !isShowLoading && setIsMessageLoading(true);
    const endPoint = "messages/get";
    const payload = {
      conversationId: conversationId,
      page: curretPage,
      limit: 20,
    };
    const response = await postApiCaller(endPoint, payload);
    let isOk = true;

    // Check if conversationId changed during fetch
    const currentConvID = typeof chatConversationId == "string"
      ? chatConversationId
      : chatConversationId?._id;
    if (currentConvID !== conversationId) {
      isOk = false;
    }

    if (response.status === 200 && isOk) {
      const reversedArray = [...response.data.data];
      const finalMessages = shouldAppend
        ? [...allMessages, ...reversedArray]
        : reversedArray;


      // Update both state and cache
      const cached = messagesCacheRef.current.get(conversationId) || {};
      messagesCacheRef.current.set(conversationId, {
        messages: finalMessages,
        timestamp: Date.now(),
        page: response.data.pagination.currentPage,
        totalPages: response.data.pagination.totalPages,
        secretKey: cached.secretKey, // Preserve secret key in cache
      });
      setAllMessages(finalMessages);

      if (isChatRoute) {
        setChatUsers((prev) =>
          prev.map((user) => {
            const userConvId = user.conversationId?._id || user.conversationId;
            if (userConvId === conversationId) {
              return {
                ...user,
                unseenMessageCount: 0,
              };
            }
            return user;
          })
        );
        setMessageCurrentPage(response.data.pagination.currentPage);
        setMessageTotalPages(response.data.pagination.totalPages);
      }
      if (isGroupRoute) {
        setAllGroups((prev) => {
          return prev.map((group) => {
            if (group?._id === groupActiveChat?._id) {
              return { ...group, unseenMessageCount: 0 };
            }
            return group;
          });
        });
      }
      if (isChannelRoute) {
        setChannels((prev) => {
          return prev.map((channel) => {
            if (channel?._id === channelActiveChat?._id) {
              return { ...channel, unseenMessageCount: 0 };
            }
            return channel;
          });
        });
      }
      setGroupPage(curretPage);
      setTotalPages(response.data.pagination.totalPages);
      setIsMessageLoading(false);
    } else {
      toast.error(response?.response?.data?.message || response.message);
      setIsMessageLoading(false);
    }
  };

  // Original fetchMessages function - wraps fetchMessagesForConversation for backward compatibility
  const fetchMessages = async (
    curretPage,
    isShowLoading,
    shouldAppend = false
  ) => {
    const currentConvID =
      typeof chatConversationId == "string"
        ? chatConversationId
        : chatConversationId?._id;
    if (!currentConvID) {
      console.error("No conversationId available for fetchMessages");
      setIsMessageLoading(false);
      return;
    }
    return fetchMessagesForConversation(currentConvID, curretPage, isShowLoading, shouldAppend);
  };

  const messageHandler = async (data) => {
    console.log('[SOCKET] messageHandler called', {
      hasData: !!data,
      hasMessage: !!data?.message,
      messageId: data?.message?.messageId,
      conversationId: data?.message?.conversationId,
      currentConversationId: conversationIdRef.current,
      messageType: data?.message?.messageType,
      hasMediaUrl: !!data?.message?.mediaUrl,
      mediaUrl: data?.message?.mediaUrl
    });

    if (isChatRoute) {
      setChatUsers((prev) =>
        prev.map((user) => {
          if (user.conversationId._id === chatConversationId._id) {
            return {
              ...user,
              unseenMessageCount: 0,
            };
          }
          return user;
        })
      );
    } else if (isGroupRoute) {
      setAllGroups((prev) => {
        return prev.map((group) => {
          if (group._id === data.message.conversationId) {
            return { ...group, unseenMessageCount: 0 };
          }
          return group;
        });
      });
    }
    if (isChannelRoute) {
      setChannels((prev) => {
        return prev.map((channel) => {
          if (channel._id === data.message.conversationId) {
            return { ...channel, unseenMessageCount: 0 };
          }
          return channel;
        });
      });
    }
    // Check if this message belongs to the current conversation
    const messageConversationId = typeof data.message.conversationId === 'object'
      ? data.message.conversationId._id || data.message.conversationId
      : data.message.conversationId;
    const currentConvId = typeof conversationIdRef.current === 'object'
      ? conversationIdRef.current?._id || conversationIdRef.current
      : conversationIdRef.current;

    console.log('[SOCKET] Checking conversation match', {
      messageConversationId,
      currentConvId,
      matches: String(messageConversationId) === String(currentConvId),
      messageId: data.message.messageId
    });

    if (String(messageConversationId) === String(currentConvId)) {
      socket.emit("messageSeen", {
        messageId: data.message._id,
        userId: uid,
      });
      setAllMessages((prevMsg) => {
        // Helper to normalize senderId structure - ensure it's always { _id: "..." }
        const normalizeSenderId = (message) => {
          if (!message || !message.senderId) {
            return message;
          }

          const originalSenderId = message.senderId;
          const normalized = { ...message };

          // Check if senderId is already in correct format { _id: "..." }
          if (typeof message.senderId === 'object' && message.senderId._id && Object.keys(message.senderId).length === 1) {
            // Already in correct format
            normalized.senderId = message.senderId;
          } else if (typeof message.senderId === 'string') {
            // Convert string to object format
            normalized.senderId = { _id: message.senderId };
          } else if (typeof message.senderId === 'object') {
            // It's an object - check if it has _id property
            if (message.senderId._id) {
              // Has _id property, extract it
              normalized.senderId = { _id: String(message.senderId._id) };
            } else {
              // Populated object without _id - backend bug, but we can work around it
              // Try to find the senderId from the previous message with same messageId
              const prevMessage = prevMsg.find(m => m.messageId === message.messageId);
              if (prevMessage && prevMessage.senderId && prevMessage.senderId._id) {
                // Use the senderId from the previous message (which was correct)
                normalized.senderId = { _id: String(prevMessage.senderId._id) };
              } else {
                // Last resort: check if message has userId or sender field
                const fallbackId = message.userId || message.sender;
                if (fallbackId) {
                  normalized.senderId = { _id: String(fallbackId) };
                } else {
                  // Don't modify - return as-is and let the comparison fail (better than wrong value)
                  return message;
                }
              }
            }
          } else {
            // Unknown format
            return message;
          }

          return normalized;
        };

        // If message is deleted, filter it out
        let updatedMessages;
        let finalMessageIndex = -1; // Declare outside to avoid scope issues
        if (data.message.isDeleted) {
          updatedMessages = prevMsg.filter(
            (msg) => msg.messageId !== data.message.messageId
          );
        } else {
          // Normalize senderId structure from socket message

          const normalizedMessage = normalizeSenderId(data.message);


          // CRITICAL: Match by messageId first (this is the UUID we send from frontend)
          const messageExists = prevMsg.findIndex(
            (msg) => msg.messageId === data.message.messageId
          );

          // Also check by _id as fallback (in case messageId doesn't match)
          // This handles cases where the backend might not preserve the messageId
          const messageExistsById = messageExists === -1
            ? prevMsg.findIndex((msg) => {
              const msgId = typeof msg._id === 'object' ? msg._id.toString() : String(msg._id);
              const socketId = typeof data.message._id === 'object' ? data.message._id.toString() : String(data.message._id);
              // Match if IDs are the same (both real DB IDs)
              // OR if local has temp ID and socket has real ID (we'll update the temp to real)
              return msgId === socketId || (msgId.length < 15 && socketId.length >= 15);
            })
            : -1;

          finalMessageIndex = messageExists !== -1 ? messageExists : messageExistsById;

          // Log matching details
          if (finalMessageIndex === -1) {
            console.warn('[SOCKET] Message not found in state!', {
              socketMessageId: data.message.messageId,
              socketId: data.message._id,
              allLocalMessageIds: prevMsg.slice(0, 5).map(m => ({
                messageId: m.messageId,
                _id: m._id,
                loading: m.loading
              }))
            });
          }

          console.log('[SOCKET] message-sent event received', {
            messageId: data.message.messageId,
            socketMessageId: data.message._id,
            conversationId: data.message.conversationId,
            messageExists: messageExists !== -1,
            messageExistsById: messageExistsById !== -1,
            finalMessageIndex,
            hasMedia: !!data.message.mediaId,
            mediaUrl: data.message.mediaUrl,
            messageType: data.message.messageType,
            allMessageIds: prevMsg.slice(0, 3).map(m => ({
              messageId: m.messageId,
              _id: m._id,
              loading: m.loading
            }))
          });

          if (finalMessageIndex === -1) {
            // New message - add it to the list
            // Ensure media data is preserved if it exists
            // CRITICAL: Preserve mediaId structure from backend (it has fileType)
            const mediaId = normalizedMessage.mediaId
              ? (typeof normalizedMessage.mediaId === 'object' && normalizedMessage.mediaId.fileType
                ? normalizedMessage.mediaId
                : { _id: normalizedMessage.mediaId, fileType: data.message.fileType || 'image' })
              : null;

            const messageToAdd = {
              ...normalizedMessage,
              loading: false, // New messages from socket are never loading
              // Ensure mediaId has the correct structure with fileType
              mediaId: mediaId,
              // CRITICAL: Ensure mediaUrl is set - backend provides it directly
              mediaUrl: normalizedMessage.mediaUrl || null,
            };

            // Backend provides mediaUrl directly, but ensure it's set for media messages
            // If mediaUrl is missing but we have mediaId, log a warning
            if (normalizedMessage.messageType === 'MEDIA' && !messageToAdd.mediaUrl) {
              console.warn('[SOCKET] Media message missing mediaUrl', {
                messageId: data.message.messageId,
                mediaId: normalizedMessage.mediaId,
                fileType: data.message.fileType,
                rawMessage: data.message,
                normalizedMessage: normalizedMessage
              });
            }

            updatedMessages = [messageToAdd, ...prevMsg];
            console.log('[SOCKET] Added new message', {
              messageId: data.message.messageId,
              hasMediaUrl: !!messageToAdd.mediaUrl,
              mediaUrl: messageToAdd.mediaUrl,
              messageType: messageToAdd.messageType,
              hasMediaId: !!messageToAdd.mediaId,
              mediaIdStructure: messageToAdd.mediaId,
              fileType: messageToAdd.mediaId?.fileType
            });
          } else {
            const existingMessage = prevMsg[finalMessageIndex];

            // CRITICAL: Log BEFORE update to see what we're working with
            console.log('[SOCKET] BEFORE UPDATE - Existing message found', {
              messageIndex: finalMessageIndex,
              messageId: existingMessage.messageId,
              socketMessageId: data.message.messageId,
              existingId: existingMessage._id,
              socketId: data.message._id,
              existingLoading: existingMessage.loading,
              existingMediaUrl: existingMessage.mediaUrl,
              socketMediaUrl: normalizedMessage.mediaUrl,
              existingMessageFull: {
                messageId: existingMessage.messageId,
                _id: existingMessage._id,
                loading: existingMessage.loading,
                mediaUrl: existingMessage.mediaUrl,
                messageType: existingMessage.messageType
              },
              // Log the ENTIRE message object to see all properties
              completeExistingMessage: JSON.parse(JSON.stringify(existingMessage))
            });

            const existingSenderId = existingMessage.senderId?._id || existingMessage.senderId;
            const newSenderId = normalizedMessage.senderId?._id || normalizedMessage.senderId;

            // Check if the senderId is actually different
            const senderIdChanged = String(existingSenderId) !== String(newSenderId);

            // Check if loading status needs to change
            // When socket message arrives, loading is undefined, but if existing message was loading, we should stop it
            const wasLoading = existingMessage.loading === true;
            const loadingChanged = wasLoading; // If it was loading, we need to stop it

            // Check if isEdited changed (only if it actually changed, not just undefined -> false)
            const newIsEdited = data.message.isEdited ? true : false;
            const isEditedChanged = existingMessage.isEdited !== newIsEdited &&
              !(existingMessage.isEdited === undefined && newIsEdited === false);

            // Check if message content changed (cipherText or iv)
            const contentChanged = existingMessage.cipherText !== normalizedMessage.cipherText ||
              existingMessage.iv !== normalizedMessage.iv;

            // Check if _id changed (temporary local ID -> real database ID)
            // This is expected and shouldn't trigger a full update if nothing else changed
            const idChanged = existingMessage._id !== normalizedMessage._id;
            const isTemporaryId = existingMessage._id && existingMessage._id.length < 15; // Temporary IDs are short random strings

            // Only update if something meaningful changed
            // idChanged alone is not enough if it's just temp -> real ID transition
            const hasRealChanges = senderIdChanged || loadingChanged || isEditedChanged || contentChanged || (idChanged && !isTemporaryId);

            // CRITICAL: If message was loading, ALWAYS update to stop the spinner
            // Don't skip updates for loading messages, even if nothing else changed
            if (wasLoading || hasRealChanges) {
              updatedMessages = [...prevMsg];

              // Full update needed
              // Preserve mediaUrl from existing message if socket message doesn't have it
              // Backend provides mediaUrl directly, prefer that over constructing from mediaId
              // CRITICAL: For media messages, always prefer the backend's mediaUrl over the local blob URL
              const mediaUrl = normalizedMessage.mediaUrl || existingMessage.mediaUrl;

              // Preserve the local blob URL only if backend doesn't provide one yet
              // This ensures the image shows immediately on sender side
              const finalMediaUrl = normalizedMessage.mediaUrl
                ? normalizedMessage.mediaUrl  // Backend URL takes priority
                : existingMessage.mediaUrl;   // Fall back to local blob URL

              console.log('[SOCKET] MediaUrl decision', {
                messageId: data.message.messageId,
                backendMediaUrl: normalizedMessage.mediaUrl,
                localBlobUrl: existingMessage.mediaUrl,
                finalMediaUrl,
                messageType: normalizedMessage.messageType,
                hasMediaId: !!normalizedMessage.mediaId
              });

              // CRITICAL: Preserve mediaId object structure
              // Socket sends mediaId as string (database ID), but we need the object with fileType
              // for rendering condition: chat.mediaId.fileType === "image"
              const preservedMediaId = existingMessage.mediaId && typeof existingMessage.mediaId === 'object'
                ? existingMessage.mediaId  // Keep the object with fileType
                : normalizedMessage.mediaId; // Use socket value if no existing object

              updatedMessages[finalMessageIndex] = {
                ...existingMessage, // Preserve existing fields first
                ...normalizedMessage, // Then apply normalized message
                // CRITICAL: Explicitly set loading to false as a separate property
                // Don't rely on spread operator - force it to be false
                loading: false,
                isEdited: data.message.isEdited ? true : false,
                // Only update senderId if it actually changed
                senderId: senderIdChanged ? normalizedMessage.senderId : existingMessage.senderId,
                // Use backend mediaUrl if available, otherwise keep local blob URL
                mediaUrl: finalMediaUrl,
                // CRITICAL: Preserve mediaId object structure for rendering
                mediaId: preservedMediaId,
                // Update _id to real database ID if it changed
                _id: normalizedMessage._id || existingMessage._id,
              };

              // CRITICAL FIX: Double-check and force loading to false
              // This ensures even if spread operator fails, loading is definitely false
              if (updatedMessages[finalMessageIndex].loading !== false) {
                console.error('[SOCKET] CRITICAL: Loading was not set to false, forcing it now!', {
                  messageId: data.message.messageId,
                  loadingValue: updatedMessages[finalMessageIndex].loading
                });
                updatedMessages[finalMessageIndex] = {
                  ...updatedMessages[finalMessageIndex],
                  loading: false
                };
              }

              // Log if media message is missing mediaUrl
              if (normalizedMessage.messageType === 'MEDIA' && !mediaUrl) {
                console.warn('[SOCKET] Media message missing mediaUrl after update', {
                  messageId: data.message.messageId,
                  existingMediaUrl: existingMessage.mediaUrl,
                  normalizedMediaUrl: normalizedMessage.mediaUrl
                });
              }

              // CRITICAL: Log AFTER update to verify the change
              const updatedMessage = updatedMessages[finalMessageIndex];
              console.log('[SOCKET] AFTER UPDATE - Message updated', {
                messageId: data.message.messageId,
                wasLoading,
                loadingBefore: existingMessage.loading,
                loadingAfter: updatedMessage.loading,
                hasMediaUrl: !!updatedMessage.mediaUrl,
                mediaUrl: updatedMessage.mediaUrl,
                mediaId: updatedMessage.mediaId,
                mediaIdType: typeof updatedMessage.mediaId,
                mediaIdFileType: updatedMessage.mediaId?.fileType,
                messageIndex: finalMessageIndex,
                arrayReferenceChanged: updatedMessages !== prevMsg,
                messageReferenceChanged: updatedMessage !== existingMessage,
                fullUpdatedMessage: {
                  messageId: updatedMessage.messageId,
                  _id: updatedMessage._id,
                  loading: updatedMessage.loading,
                  mediaUrl: updatedMessage.mediaUrl,
                  messageType: updatedMessage.messageType
                },
                // Verify the update actually changed the loading state
                loadingStateChanged: existingMessage.loading !== updatedMessage.loading,
                // Log the ENTIRE updated message object to see all properties
                completeUpdatedMessage: JSON.parse(JSON.stringify(updatedMessage)),
                // Critical check: Is loading actually false?
                loadingIsFalse: updatedMessage.loading === false,
                loadingIsUndefined: updatedMessage.loading === undefined,
                loadingIsTrue: updatedMessage.loading === true
              });
            } else if (idChanged && isTemporaryId) {
              // Only _id changed from temp to real, do minimal update
              // But still create a new array to trigger re-render
              updatedMessages = [...prevMsg];
              updatedMessages[finalMessageIndex] = {
                ...existingMessage,
                _id: normalizedMessage._id, // Update to real database ID
              };
            } else {
              // No real changes - don't update to prevent unnecessary re-render
              return prevMsg; // Return same array reference to prevent re-render
            }
          }
        }
        // CRITICAL: Ensure updatedMessages is always defined
        if (!updatedMessages) {
          console.error('[SOCKET] updatedMessages is undefined! This should never happen.', {
            messageId: data.message.messageId,
            finalMessageIndex,
            wasDeleted: data.message.isDeleted
          });
          return prevMsg; // Fallback to prevent crash
        }

        // Update cache when messages change via socket
        const conversationId = typeof chatConversationId === "string"
          ? chatConversationId
          : chatConversationId?._id;
        if (conversationId) {
          const cached = messagesCacheRef.current.get(conversationId) || {};
          messagesCacheRef.current.set(conversationId, {
            messages: updatedMessages,
            timestamp: Date.now(),
            page: cached.page || messageCurrentPage,
            totalPages: cached.totalPages || messageTotalPages,
            secretKey: cached.secretKey, // Preserve secret key
          });
        }

        // Final verification log
        const loadingMessages = updatedMessages.filter(m => m.loading === true);
        if (loadingMessages.length > 0) {
          console.log('[SOCKET] WARNING: Still have loading messages after update', {
            count: loadingMessages.length,
            messageIds: loadingMessages.map(m => ({ messageId: m.messageId, _id: m._id }))
          });
        }

        return updatedMessages;
      });
    }
  };

  const conversationRefreshHandler = (data) => {
    if (data.type === "chat") {
      if (!isChatRoute) {
        setOtherChannelChatMsg((prev) => ({
          ...prev,
          chat: true,
        }));
      }
      setChatUsers((prev) => {
        if (prev.findIndex((user) => user._id === data.id) === -1) {
          setIsNewUserMessage(true);
          return prev;
        }
        const updatedUsers = prev.filter((user) => user._id !== data.id);
        const targetUser = prev.find((user) => user._id === data.id);
        if (
          !data.message.isPrevDeleted &&
          data.message.isEdited &&
          data.message._id !== targetUser?.latestMessage?._id
        ) {
          return prev;
        }

        const updatedUser = {
          ...targetUser,
          latestMessage: data.message,
          unseenMessageCount:
            data.message.conversationId === conversationIdRef.current ||
              data.message?.senderId?._id === uid
              ? 0
              : targetUser?.unseenMessageCount +
              (data.message.isPrevDeleted || data.message.isEdited ? 0 : 1),
        };
        return [updatedUser, ...updatedUsers];
      });
    }

    if (data.type === "group") {
      if (!isGroupRoute) {
        setOtherChannelChatMsg((prev) => ({
          ...prev,
          group: true,
        }));
      }
      setAllGroups((prevGroups) => {
        if (prevGroups.findIndex((group) => group._id === data.id) === -1) {
          fetchGroups(true, 1);
          return prevGroups;
        }
        const updatedGroups = prevGroups.filter(
          (group) => group._id !== data.id
        );
        const targetGroup = prevGroups.find((group) => group._id === data.id);

        if (!targetGroup) {
          return prevGroups;
        }

        // Don't update if it's an edited message that doesn't match latest
        if (
          !data.message.isPrevDeleted &&
          data.message.isEdited &&
          data.message._id !== targetGroup.latestMessage._id
        ) {
          return prevGroups;
        }

        const isActiveGroup = groupActiveChat?._id === targetGroup._id;

        const updatedGroup = {
          ...targetGroup,
          latestMessage:
            Array.isArray(data.message.recievedBy) &&
              data.message.recievedBy.includes(uid)
              ? data.message
              : {},
          unseenMessageCount:
            data.message.conversationId === conversationIdRef.current ||
              isActiveGroup ||
              data.message?.senderId?._id === uid
              ? 0
              : targetGroup.unseenMessageCount +
              (data.message.isPrevDeleted || data.message.isEdited ? 0 : 1),
        };

        return [updatedGroup, ...updatedGroups];
      });
    }

    if (data.type === "channel") {
      if (!isChannelRoute) {
        setOtherChannelChatMsg((prev) => ({
          ...prev,
          channel: true,
        }));
      }
      setChannels((prevChannels) => {
        if (
          prevChannels.findIndex((channel) => channel._id === data.id) === -1
        ) {
          fetchChannels(true, 1);
          return prevChannels;
        }
        const updatedChannels = prevChannels.filter(
          (channel) => channel._id !== data.id
        );
        const targetChannel = prevChannels.find(
          (channel) => channel._id === data.id
        );

        if (
          !data.message.isPrevDeleted &&
          data.message.isEdited &&
          data.message._id !== targetChannel.latestMessage._id
        ) {
          return prevChannels;
        }

        // if (targetChannel && targetChannel?.latestMessage?.senderId === uid) {
        const updatedUser = {
          ...targetChannel,
          latestMessage: data.message,
          unseenMessageCount:
            data.message.conversationId === conversationIdRef.current
              ? 0
              : targetChannel?.unseenMessageCount +
              (data.message.isPrevDeleted || data.message.isEdited ? 0 : 1),
        };
        return [updatedUser, ...updatedChannels];
        // }
      });
    }
  };

  const updateChats = (data, id) => {
    try {
      if ("deleted" in data) {
        if (activeChat && activeChat?._id == id) {
          toast.info("User deleted...");
          setActiveChat(null);
        }
        setChatUsers((prev) => prev.filter((ele) => ele._id != id));
      } else {
        setActiveChat((prev) => {
          if (prev && prev?._id == id) {
            return {
              ...prev,
              user: {
                ...prev.user,
                ...data,
                ...(data.avtarImage && { mediaUrl: null }),
              },
            };
          }
          return prev;
        });
        setChatUsers((prev) => {
          const alreadyUser = prev.findIndex((ele) => ele._id == id);
          if (alreadyUser != -1) {
            prev[alreadyUser].user = {
              ...prev[alreadyUser].user,
              ...data,
              ...(data.avtarImage && { mediaUrl: null }),
            };
            return [...prev];
          } else {
            return [data, ...prev];
          }
        });
      }
    } catch (err) {
      // console.log("error updating chats", err);
    }
  };

  const updateChannel = (data, id) => {
    try {
      if (
        Object.keys(data).some((ele) =>
          [
            "newAdmin",
            "deletedUsers",
            "removedAdmin",
            "deleted",
            "newUsers",
          ].includes(ele)
        )
      ) {
        if ("deleted" in data) {
          setChannelActiveChat((prev) => {
            if (prev?._id == id) {
              setActiveSection("contact");
              setShowProfileView(false);
              setAllMessages([]);
              return null;
            }
            return prev;
          });
          setChannels((prev) => prev.filter((ele) => ele._id != id));
        }
        if ("deletedUsers" in data) {
          const userId = localStorage.getItem("userId");
          if (data.deletedUsers.includes(userId)) {
            setChannelActiveChat((prev) => {
              if (prev && prev?._id == id) {
                toast.info(
                  `You have been removed from the channel - ${prev.channelName}`
                );
                setActiveSection("");
                setShowProfileView(false);
                setAllMessages([]);
                setChannelCurrentPage(1);
                return null;
              }
              return prev;
            });
          } else {
            setChannelActiveChat((prev) => {
              if (!prev) return prev;
              if (prev?._id != id) return prev;
              return {
                ...prev,
                users: prev.users.filter(
                  (user) => !data.deletedUsers.includes(user._id)
                ),
              };
            });
          }
          setChannels((prev) => {
            const channelIndex = prev.findIndex((ele) => ele._id == id);
            if (channelIndex != -1) {
              if (data.deletedUsers.some((user) => user === userId)) {
                return prev.filter((channel) => channel._id !== id);
              }
              prev[channelIndex].users = prev[channelIndex].users.filter(
                (user) => !data.deletedUsers.includes(user._id)
              );
              return [...prev];
            }
            return prev;
          });
        }
        if ("newUsers" in data) {
          if (
            data.newUsers
              .map((ele) => ele._id)
              .includes(localStorage.getItem("userId"))
          ) {
            fetchChannels(true);
          } else {
            setChannelActiveChat((prev) => {
              if (!prev) return prev;
              if (prev?._id != id) return prev;
              return {
                ...prev,
                users: [
                  ...prev.users,
                  ...data.newUsers.filter(
                    (newUser) =>
                      !prev.users.some(
                        (existingUser) => existingUser._id === newUser._id
                      )
                  ),
                ],
              };
            });
          }
          setChannels((prev) => {
            const channelIndex = prev.findIndex((ele) => ele._id == id);
            if (channelIndex != -1) {
              prev[channelIndex].users = [
                ...prev[channelIndex].users,
                ...data.newUsers.filter(
                  (newUser) =>
                    !prev[channelIndex].users.some(
                      (existingUser) => existingUser._id === newUser._id
                    )
                ),
              ];
              return [...prev];
            }
            return prev;
          });
        }
        if ("newAdmin" in data || "removedAdmin" in data) {
          setChannelActiveChat((prev) => {
            if (!prev) return prev;
            if (prev?._id != id) return prev;
            return {
              ...prev,
              adminId: data.newAdmin
                ? [
                  ...prev.adminId,
                  ...prev.users.filter((user) =>
                    data.newAdmin.includes(user._id)
                  ),
                ]
                : prev.adminId.filter(
                  (admin) => !data.removedAdmin.includes(admin._id)
                ),
            };
          });
          setChannels((prev) => {
            const channelIndex = prev.findIndex((ele) => ele._id == id);
            if (channelIndex != -1) {
              if (data.newAdmin) {
                prev[channelIndex].adminId = [
                  ...prev[channelIndex].adminId,
                  ...prev[channelIndex].users.filter((user) =>
                    data.newAdmin.includes(user._id)
                  ),
                ];
              } else {
                prev[channelIndex].adminId = prev[channelIndex].adminId.filter(
                  (admin) => !data.removedAdmin.includes(admin._id)
                );
              }
              return [...prev];
            }
            return prev;
          });
        }
      } else {
        setChannelActiveChat((prev) => {
          if (!prev) return prev;
          if (prev?._id != id) return prev;
          return { ...prev, ...data };
        });
        setChannels((prev) => {
          const alreadyChannel = prev.findIndex((ele) => ele._id == id);
          if (alreadyChannel != -1) {
            prev[alreadyChannel] = { ...prev[alreadyChannel], ...data };
            return [...prev];
          } else {
            return [data, ...prev];
          }
        });
      }
    } catch (err) {
      // console.log("error updating channel", err);
    }
  };

  const updateGroup = async (data, id) => {
    try {
      if (
        Object.keys(data).some((ele) =>
          [
            "newAdmin",
            "deletedUsers",
            "removedAdmin",
            "deleted",
            "newUsers",
          ].includes(ele)
        )
      ) {
        if ("deleted" in data) {
          toast.success("Group deleted successfully");
          setGroupActiveChat((prev) => {
            if (prev?._id == id) return null;
            if (groupActiveChat && groupActiveChat._id === id) {
              socket.emit("disconnectConversation", {
                id: groupActiveChat?.conversationId?._id,
              });
              dispatch(converId(""));
              setGroupActiveChat(null);
              setChatConversationId(null);
              setGetSecretKey(null);
              setShowProfileView(false);
              setActiveSection("");
              setAllMessages([]);
              setGroupPage(1);
            }
            return prev;
          });
          setAllGroups((prev) => prev.filter((ele) => ele._id != id));
        }
        if ("deletedUsers" in data) {
          const userId = localStorage.getItem("userId");
          setAllGroups((prev) => {
            const groupObject = prev.find((ele) => ele?._id === id);

            if (groupObject) {
              if (userId === data.deletedUsers[0]) {
                toast.info(
                  `You have been removed from this group - ${groupObject?.groupName}`
                );
                setGroupActiveChat((prev) => {
                  if (prev && prev?._id === id) {
                    setShowProfileView(false);
                    setActiveSection("");
                    setAllMessages([]);
                    setGroupPage(1);
                    return null;
                  }
                  return prev;
                });
              }
            }
            return [...prev];
          });
          // setGroupActiveChat((prev) => {
          //   if (prev && prev?._id === id) {
          //     toast.info(
          //       `You have been removed from this group - ${prev.groupName}`
          //     );
          //     return null;
          //   }
          //   return prev;
          // });
          if (!data.deletedUsers.includes(userId)) {
            setGroupActiveChat((prev) => {
              if (!prev) return prev;
              if (prev?._id != id) return prev;
              return {
                ...prev,
                users: prev.users.filter(
                  (user) => !data.deletedUsers.includes(user._id)
                ),
              };
            });
          }

          setAllGroups((prev) => {
            const groupIndex = prev.findIndex((ele) => ele._id == id);
            if (groupIndex != -1) {
              if (data.deletedUsers.some((user) => user == userId)) {
                return prev.filter((group) => group._id !== id);
              }
              prev[groupIndex].users = prev[groupIndex].users.filter(
                (user) => !data.deletedUsers.includes(user._id)
              );
              return [...prev];
            }
            return prev;
          });
        }
        if ("newUsers" in data) {
          if (
            data.newUsers
              .map((ele) => ele._id)
              .includes(localStorage.getItem("userId"))
          ) {
            await fetchGroups(true, 1);
            if (
              data.newUsers
                .map((ele) => ele._id)
                .includes(localStorage.getItem("userId"))
            ) {
              setAllGroups((prev) => {
                const groupObject = prev.find((ele) =>
                  ele?.users
                    ?.map((user) => user?._id)
                    .includes(localStorage.getItem("userId"))
                );
                if (groupObject) {
                  toast.info(
                    `You have been added in this group - ${groupObject?.groupName}`
                  );
                }
                return [...prev];
              });
            }
          } else {
            setGroupActiveChat((prev) => {
              if (!prev) return prev;
              if (prev?._id != id) return prev;
              return {
                ...prev,
                users: [
                  ...prev.users,
                  ...data.newUsers.filter(
                    (newUser) =>
                      !prev.users.some(
                        (existingUser) => existingUser._id === newUser._id
                      )
                  ),
                ],
              };
            });
          }

          setAllGroups((prev) => {
            const groupIndex = prev.findIndex((ele) => ele._id == id);
            if (groupIndex != -1) {
              prev[groupIndex].users = [
                ...prev[groupIndex].users,
                ...data.newUsers.filter(
                  (newUser) =>
                    !prev[groupIndex].users.some(
                      (existingUser) => existingUser._id === newUser._id
                    )
                ),
              ];
              return [...prev];
            }
            return prev;
          });
        }
        if ("newAdmin" in data || "removedAdmin" in data) {
          setGroupActiveChat((prev) => {
            if (!prev) return prev;
            if (prev?._id != id) return prev;
            return {
              ...prev,
              adminId: data.newAdmin
                ? [
                  ...prev.adminId,
                  ...prev.users.filter((user) =>
                    data.newAdmin.includes(user._id)
                  ),
                ]
                : prev.adminId.filter(
                  (admin) => !data.removedAdmin.includes(admin._id)
                ),
            };
          });
          setAllGroups((prev) => {
            const groupIndex = prev.findIndex((ele) => ele._id == id);
            if (groupIndex != -1) {
              if (data.newAdmin) {
                prev[groupIndex].adminId = [
                  ...prev[groupIndex].adminId,
                  ...prev[groupIndex].users.filter((user) =>
                    data.newAdmin.includes(user._id)
                  ),
                ];
              } else {
                prev[groupIndex].adminId = prev[groupIndex].adminId.filter(
                  (admin) => !data.removedAdmin.includes(admin._id)
                );
              }
              return [...prev];
            }
            return prev;
          });
        }
      } else {
        setGroupActiveChat((prev) => {
          if (!prev) return prev;
          if (prev?._id != id) return prev;
          return { ...prev, ...data };
        });
        setAllGroups((prev) => {
          const alreadyGroup = prev.findIndex((ele) => ele._id == id);
          if (alreadyGroup != -1) {
            prev[alreadyGroup] = { ...prev[alreadyGroup], ...data };
            return [...prev];
          } else {
            return [data, ...prev];
          }
        });
      }
    } catch (err) {
      // console.log("error updating group", err);
    }
  };

  const conversationUpdate = (data) => {
    switch (data.type) {
      case "chat":
        updateChats(data.details, data.id);
        break;
      case "group":
        updateGroup(data.details, data.id);
        break;
      case "channel":
        updateChannel(data.details, data.id);
        break;
    }
  };

  const seenMessageHandler = (data) => {
    // Update the allMessages state to mark messages as seen
    setAllMessages((prevMessages) =>
      prevMessages.map((msg) =>
        data.messages.includes(msg._id) ? { ...msg, isSeen: true } : msg
      )
    );
  };

  const setupSocketJoinConversation = () => {
    if (chatConversationId?._id) {
      socket.emit("joinConversation", { id: chatConversationId?._id });
    }
    socket.emit("joinApp", { userId: uid });
  };

  const conversationRemoveCountHandler = (data) => {
    if (data.type === "chat") {
      setChatUsers((prev) => {
        const messageExists = prev.findIndex((msg) => msg._id === data.id);
        if (messageExists !== -1) {
          prev[messageExists].unseenMessageCount =
            prev[messageExists].unseenMessageCount <= 0
              ? 0
              : prev[messageExists].unseenMessageCount - 1;
        }
        return [...prev];
      });
    }
    if (data.type === "group") {
      setAllGroups((prev) => {
        const messageExists = prev.findIndex((msg) => msg._id === data.id);
        if (messageExists !== -1) {
          prev[messageExists].unseenMessageCount =
            prev[messageExists].unseenMessageCount <= 0
              ? 0
              : prev[messageExists].unseenMessageCount - 1;
        }
        return [...prev];
      });
    }
    if (data.type === "channel") {
      setChannels((prev) => {
        const messageExists = prev.findIndex((msg) => msg._id === data.id);
        if (messageExists !== -1) {
          prev[messageExists].unseenMessageCount =
            prev[messageExists].unseenMessageCount <= 0
              ? 0
              : prev[messageExists].unseenMessageCount - 1;
        }
        return [...prev];
      });
    }
  };

  // Debug: Log messages with loading: true and track state changes
  const prevLoadingMessagesRef = useRef([]);
  useEffect(() => {
    const loadingMessages = allMessages.filter(msg => msg.loading === true);
    const prevLoadingIds = prevLoadingMessagesRef.current.map(m => m.messageId || m._id);
    const currentLoadingIds = loadingMessages.map(m => m.messageId || m._id);

    // Check if any messages stopped loading
    const stoppedLoading = prevLoadingMessagesRef.current.filter(prev => {
      const stillLoading = currentLoadingIds.includes(prev.messageId || prev._id);
      return !stillLoading;
    });

    if (stoppedLoading.length > 0) {
      console.log('[DEBUG] Messages that stopped loading:', stoppedLoading.map(m => ({
        messageId: m.messageId,
        _id: m._id,
        loading: m.loading,
        messageType: m.messageType
      })));
    }

    if (loadingMessages.length > 0) {
      console.log('[DEBUG] Messages still loading:', loadingMessages.map(m => ({
        messageId: m.messageId,
        _id: m._id,
        loading: m.loading,
        loadingType: typeof m.loading,
        mediaUrl: m.mediaUrl,
        messageType: m.messageType,
        // Show the actual message object to debug
        fullMessage: JSON.parse(JSON.stringify(m))
      })));
    }

    // Update ref for next comparison
    prevLoadingMessagesRef.current = loadingMessages;
  }, [allMessages]);

  useEffect(() => {
    // Clean up the event listeners on component unmount
    if (isConnected && socket) {
      const userId = localStorage.getItem("userId");
      socket.emit("joinApp", { userId });
      socket.on("message-sent", messageHandler);
      socket.on("conversation-refresh", conversationRefreshHandler);
      socket.on("conversation-remove-count", conversationRemoveCountHandler);
      socket.on("conversation-updated", conversationUpdate);
      socket.on("seen-message", seenMessageHandler);

      // Reaction events
      socket.on("reaction_updated", (data) => {
        setAllMessages((prev) => prev.map((msg) =>
          msg._id === data.messageId
            ? { ...msg, reactions: data.reactions }
            : msg
        ));
      });
      // setupSocketListeners();

      // Return cleanup function
      return () => {
        if (socket) {
          socket.off("message-sent", messageHandler);
          socket.off("conversation-refresh", conversationRefreshHandler);
          socket.off("conversation-updated", conversationUpdate);
          socket.off("seen-message", seenMessageHandler);
          socket.off("reaction_updated");
        }
      };
    }
  }, [isConnected]);

  // Collect all conversation IDs from chats, groups, and channels
  const allConversationIds = useMemo(() => {
    const conversations = [];

    // Add chat conversations
    chatUsers.forEach(chat => {
      const convId = chat?.conversationId?._id || chat?.conversationId;
      if (convId) conversations.push(convId);
    });

    // Add group conversations
    allGroups.forEach(group => {
      const convId = group?.conversationId?._id || group?.conversationId;
      if (convId) conversations.push(convId);
    });

    // Add channel conversations
    channels.forEach(channel => {
      const convId = channel?.conversationId?._id || channel?.conversationId;
      if (convId) conversations.push(convId);
    });

    return conversations;
  }, [chatUsers, allGroups, channels]);

  // Initialize notification system
  useNotificationSystem(userInfo, activeChat, getSecretKey, chatConversationId, allConversationIds);


  // useEffect(() => {
  //   if (isSocketConnected) {
  //     setupSocketJoinConversation();
  //     socket.on("message-sent", messageHandler);
  //     socket.on("conversation-refresh", conversationRefreshHandler);
  //     socket.on("seen-message", seenMessageHandler);
  //     fetchChatList(true, "");
  //     if (conversationId) {
  //       fetchMessages(1, true);
  //     }
  //   }
  // }, [isSocketConnected]);

  const scrollfetchingData = async () => {
    await fetchMessages(groupPage + 1, true, true);
  };

  const scrollfetchingChatData = async () => {
    await fetchMessages(messageCurrentPage + 1, true, true);
  };

  const getChannelDetails = async (channelId) => {
    const endpoint = `channel/slug/${channelId}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      if (!response?.data?.data?.isPublic) {
        toast.error("Channel is private");
        setIsMessageLoading(false);
        return;
      }
      setShowProfileView(false);
      setChannelActiveChat(null);
      setAllMessages([]);
      setGroupPage(1);
      setChannelActiveChat(response.data.data);
      setChatConversationId(response.data.data?.conversation);
      const [getKey] = await Promise.all([
        decryptText(
          response.data.data?.conversation?.AESKeyOfUser,
          userInfo?.encryptedPrivateKey
        ),
        getSettings("channel", response.data.data._id),
      ]);
      setGetSecretKey(getKey);
    } else {
      toast.error(response?.response?.data?.message || response?.message);
      setIsMessageLoading(false);
    }
  };

  const getSettings = async (type, id) => {
    const endpoint = `setting?${type}Id=${id}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      setSettings({
        muteNotification: false,
        chatColor: "#7104F8",
        background: "#f8f6ff",
        ...response.data.data,
      });
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const onChannelSelect = async (channel) => {
    // if (channelActiveChat?._id == channel?._id) return;
    const joinConversation = (conId) => {
      socket.emit("joinConversation", { id: conId });
    };
    const handleChatChangeConversation = async (conId) => {
      socket.emit("disconnectConversation", { id: conId });
    };
    setShowProfileView(false);
    setChannelActiveChat(null);
    setAllMessages([]);
    setGroupPage(1);
    dispatch(converId(channel?.conversationId?._id));
    setChatConversationId((prev) => {
      if (prev?._id) {
        handleChatChangeConversation(prev?._id);
      }
      joinConversation(channel?.conversationId?._id);
      return channel?.conversationId;
    });
    setChannelActiveChat(channel);
    const [getKey] = await Promise.all([
      decryptText(
        channel?.conversationId?.AESKeyOfUser,
        userInfo?.encryptedPrivateKey
      ),
      getSettings("channel", channel._id),
    ]);
    setGetSecretKey(getKey);
  };

  const handleAllUserSearch = (e) => {
    const value = e.target.value;
    setAllUserSearch(value);
    clearTimeout(timeOutIdForSearch);
    const timeoutID = setTimeout(() => {
      fetchAllUser(1, value);
    }, 300);
    setTimeOutIdForSearch(timeoutID);
  };

  // const [isMobileView, setIsMobileView] = useState(false);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobileView(window.innerWidth < 1600);
  //   };

  //   // Set initial value
  //   handleResize();

  //   // Add event listener
  //   window.addEventListener("resize", handleResize);

  //   // Cleanup
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);


  return (
    <div className="flex h-screen flex-col bg-zinc-50 dark:bg-slate-950">
      <div className="flex flex-1 overflow-hidden gap-4 p-3">
        {/* Mini Sidebar */}
        <nav className="flex flex-col w-[118px] h-[calc(100vh-24px)] m-3 rounded-2xl bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl shadow-sm border border-white/20 dark:border-slate-700/20">
          <aside className="w-[100px] h-full hidden md:flex border-r border-[#EBEBEB] dark:border-[#333] z-50">
            <MiniSideBar
              otherChannelChatMsg={otherChannelChatMsg}
              setOtherChannelChatMsg={setOtherChannelChatMsg}
            />
          </aside>
          <div className="mt-auto p-4 flex justify-center">
            <ThemeToggle />
          </div>
        </nav>

        {/* Sidebar */}
        <nav className="flex min-w-[424px] max-w-[424px] h-[calc(100vh-24px)] rounded-2xl bg-white/60 dark:bg-slate-900/60 backdrop-blur-lg shadow-sm border-r border-white/20 dark:border-slate-700/20">
          {isGroupRoute ? (
            <GroupChatSideBar
              AllUser={AllUser}
              userSearch={userSearch}
              setGroupActiveChat={setGroupActiveChat}
              setChatConversationId={setChatConversationId}
              setGetSecretKey={setGetSecretKey}
              fetchAllUser={fetchAllUser}
              setChatSearch={setChatSearch}
              allGroups={allGroups}
              setAllGroups={setAllGroups}
              groupActiveChat={groupActiveChat}
              fetchGroups={fetchGroups}
              currentPage={groupCurrentPage}
              totalPages={groupTotalPages}
              search={groupSearch}
              isLoading={groupLoading}
              setSearch={setGroupSearch}
              setIsLoading={setGroupLoading}
              setActiveSection={setActiveSection}
              setIsMessageLoading={setIsMessageLoading}
              allUserCurrentPage={allUserCurrentPage}
              allUserTotalPages={allUserTotalPages}
              setShowProfileView={setShowProfileView}
            />
          ) : isChannelRoute ? (
            <ChannelSidebar
              setIsMessageLoading={setIsMessageLoading}
              userSearch={userSearch}
              fetchAllUser={fetchAllUser}
              AllUser={AllUser}
              onChannelSelect={onChannelSelect}
              channelActiveChat={channelActiveChat}
              channels={channels}
              currentPage={channelCurrentPage}
              totalPages={channelTotalPages}
              search={channelSearch}
              setCurrentPage={setChannelCurrentPage}
              setSearch={setChannelSearch}
              fetchChannels={fetchChannels}
              isLoading={channelLoading}
              setIsLoading={setChannelLoading}
              allUserCurrentPage={allUserCurrentPage}
              allUserTotalPages={allUserTotalPages}
            />
          ) : isSettingsRoute ? (
            <SettingsSideBar />
          ) : (
            <ChatSideBar
              AllUser={AllUser}
              chatUsers={chatUsers}
              activeChat={activeChat}
              setActiveChat={setActiveChat}
              setCreateChatId={setCreateChatId}
              setChatConversationId={setChatConversationId}
              setGetSecretKey={setGetSecretKey}
              chatSearch={chatSearch}
              moreNewChat={moreNewChat}
              setMoreNewChat={setMoreNewChat}
              setChatSearch={setChatSearch}
              allUserSearch={allUserSearch}
              setAllUserSearch={setAllUserSearch}
              handleAllUserSearch={handleAllUserSearch}
              isAlluserLoading={isAlluserLoading}
              setChatUsers={setChatUsers}
              chatPage={chatPage}
              setShowAddMenu={setShowAddMenu}
              setChatPage={setChatPage}
              setActiveSection={setActiveSection}
              chatTotalPages={chatTotalPages}
              setChatTotalPages={setChatTotalPages}
              setIsMessageLoading={setIsMessageLoading}
              allUserCurrentPage={allUserCurrentPage}
              setAllUserCurrentPage={setAllUserCurrentPage}
              allUserTotalPages={allUserTotalPages}
              fetchAllUser={fetchAllUser}
              setShowProfileView={setShowProfileView}
              isNewUserMessage={isNewUserMessage}
              setIsNewUserMessage={setIsNewUserMessage}
            />
          )}
        </nav>

        {/* Main Content (Dynamic) */}
        <div
          className={`${showProfileView ? "xl:pr-[424px]" : ""
            } max-w-[calc(100vw-542px)] flex flex-col w-full rounded-2xl bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl shadow-sm border border-white/20 dark:border-slate-700/20`}
        >
          {isGroupRoute ? (
            <ChatingGroupSection
              hasMoreMessage={totalPages > groupPage}
              setActiveSection={setActiveSection}
              setShowProfileView={setShowProfileView}
              groupActiveChat={groupActiveChat}
              sendMessage={sendMessage}
              sendFilesInMessage={sendFilesInMessage}
              allMessages={allMessages}
              setAllMessages={setAllMessages}
              isMessageLoading={isMessageLoading}
              showAddMenu={showAddMenu}
              setShowAddMenu={setShowAddMenu}
              scrollfetchingData={scrollfetchingData}
              getSecretKey={getSecretKey}
              settings={settings}
              chatConversationId={chatConversationId}
              setAllGroups={setAllGroups}
              socket={socket}
            />
          ) : isChannelRoute ? (
            <ChatingChannelSection
              settings={settings}
              fetchChannels={fetchChannels}
              showAddMenu={showAddMenu}
              setShowAddMenu={setShowAddMenu}
              onChannelSelect={onChannelSelect}
              hasMoreMessage={totalPages > groupPage}
              channelActiveChat={channelActiveChat}
              chatConversationId={chatConversationId}
              isNewChannel={isNewChannel}
              setActiveSection={setActiveSection}
              setShowProfileView={setShowProfileView}
              showGroupSection={showGroupSection}
              sendMessage={sendMessage}
              sendFilesInMessage={sendFilesInMessage}
              allMessages={allMessages}
              setAllMessages={setAllMessages}
              isMessageLoading={isMessageLoading}
              setGroupPage={setGroupPage}
              scrollfetchingData={scrollfetchingData}
              getSecretKey={getSecretKey}
            />
          ) : isSettingsOtherRoute ? (
            <SettingsInnerPage />
          ) : (
            <ChatingSection
              isNewChannel={isNewChannel}
              setActiveSection={setActiveSection}
              setShowProfileView={setShowProfileView}
              showGroupSection={showGroupSection}
              chatConversationId={chatConversationId}
              activeChat={activeChat}
              allMessages={allMessages}
              setAllMessages={setAllMessages}
              isMessageLoading={isMessageLoading}
              sendMessage={sendMessage}
              sendFilesInMessage={sendFilesInMessage}
              getSecretKey={getSecretKey}
              settings={settings}
              showAddMenu={showAddMenu}
              setShowAddMenu={setShowAddMenu}
              scrollfetchingChatData={scrollfetchingChatData}
              hasMoreMessage={messageTotalPages > messageCurrentPage}
              setChatUsers={setChatUsers}
              typingUsers={typingUsers}
              socket={socket}
              userInfo={userInfo}
            />
          )}
        </div>

        {/* Rightbar (Hide on /home route) */}
        {showProfileView && (
          <div className="fixed top-3 right-3 h-[calc(100vh-24px)] w-[424px] rounded-2xl bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl shadow-sm border border-white/20 dark:border-slate-700/20 z-50 transition-transform duration-300 transform translate-x-0">
            {isGroupRoute ? (
              <GroupProfileView
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                setShowAddGroupMember={setShowAddGroupMember}
                chatConversationId={chatConversationId}
                secretKey={getSecretKey}
                showAddGroupMember={showAddGroupMember}
                groupActiveChat={groupActiveChat}
                setGroupActiveChat={setGroupActiveChat}
                settings={settings}
                setSettings={setSettings}
                allGroups={allGroups}
                setAllGroups={setAllGroups}
                setAllMessages={setAllMessages}
              />
            ) : isChannelRoute ? (
              <ChannelProfileView
                fetchChannels={fetchChannels}
                settings={settings}
                setSettings={setSettings}
                allUser={AllUser}
                activeChannel={channelActiveChat}
                setActiveChannel={setChannelActiveChat}
                setAllMessages={setAllMessages}
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                setShowAddGroupMember={setShowAddGroupMember}
                showAddGroupMember={showAddGroupMember}
                setChannels={setChannels}
              />
            ) : (
              <ProfileView
                getSecretKey={getSecretKey}
                chatConversationId={chatConversationId}
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                activeChat={activeChat}
                setActiveChat={setActiveChat}
                settings={settings}
                setSettings={setSettings}
                secretKey={getSecretKey}
                setAllMessages={setAllMessages}
                setChatUsers={setChatUsers}
              />
            )}
          </div>
        )}

        {/* 
        {showProfileView && (
          <nav className="flex min-w-[424px] max-w-[424px] h-full bg-white border-l border-[#EBEBEB]">
            {isGroupRoute ? (
              <GroupProfileView
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                setShowAddGroupMember={setShowAddGroupMember}
                chatConversationId={chatConversationId}
                secretKey={getSecretKey}
                showAddGroupMember={showAddGroupMember}
                groupActiveChat={groupActiveChat}
                setGroupActiveChat={setGroupActiveChat}
                settings={settings}
                setSettings={setSettings}
                allGroups={allGroups}
                setAllGroups={setAllGroups}
                setAllMessages={setAllMessages}
              />
            ) : isChannelRoute ? (
              <ChannelProfileView
                fetchAllUser={fetchAllUser}
                fetchChannels={fetchChannels}
                settings={settings}
                setSettings={setSettings}
                allUser={AllUser}
                activeChannel={channelActiveChat}
                setActiveChannel={setChannelActiveChat}
                chatConversationId={chatConversationId}
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                setShowAddGroupMember={setShowAddGroupMember}
                showAddGroupMember={showAddGroupMember}
              />
            ) : (
              <ProfileView
                getSecretKey={getSecretKey}
                chatConversationId={chatConversationId}
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                setShowProfileView={setShowProfileView}
                activeChat={activeChat}
                settings={settings}
                setSettings={setSettings}
                secretKey={getSecretKey}
                setAllMessages={setAllMessages}
              />
            )}
          </nav>
        )} */}
      </div>

    </div>
  );
}

